import React from "react";
import { selectEntitiesByFilters } from "../../../../shared/store/views/entityView";
import { selfLearningFilter } from "../../../../shared/utils/entitiesFiltersUtils";
import { useSelector } from "react-redux";
import Widget from "../../../../shared/components/features/widget/Widget";
import MyCourseItem from "../../../../shared/components/features/courseItem/myCourseItem/MyCourseItem";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import classes from "./MySelfLearningWidget.module.css";

const MySelfLearningWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const selfLearningCourses = useSelector(state => selectEntitiesByFilters(state, selfLearningFilter));

    return (
        <Widget
            color="#FDDB71"
            title={texts.myLearningSubject}
            icon={iconsList.myLearning}
            className={classes.MySelfLearningWidget}
        >
            <div className={classes.SelfLearningContent}>
                {selfLearningCourses.length > 0 ?
                    <div className={classes.CoursesList}>
                        {selfLearningCourses.map((course, index) => (
                            <MyCourseItem
                                key={course.id || course.externalId || index}
                                course={course}
                            />
                        ))}
                    </div>
                    :
                    <div className={classes.NoCourses}>
                        {texts.noProfessionalDevelopmentCourses}
                    </div>
                }
            </div>
        </Widget>
    );
};

export default MySelfLearningWidget;
